// extracted by mini-css-extract-plugin
export default {"header":"style_header__SO4J1","heading":"style_heading__MNjOr"};